import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import FilesTable from "components/Modal/UploadFilesModal/FilesTable";
import { modalTypes } from "constants/types";
import { FILE_SOURCES } from "layout/documentUploader/constants";
import { func } from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal } from "slices/app/actions/modals";
import {
  clearFileUploadStates,
  initFileUploadStates,
  updateFileUploadState,
} from "slices/workspace/foldersSlice";
import { selectFolders } from "slices/workspace/selectors";

import {
  selectCollections,
  selectSelectedCollection,
} from "../../../slices/collections/selectors";

const UploadExternalFilesModal = ({ onFilesUploaded }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const collectionList = useSelector(selectCollections);
  const collection = useSelector(selectSelectedCollection);

  const { fileUploadStates, folderId } = useSelector(selectFolders);
  const [displayedFiles, setDisplayedFiles] = useState([]);

  const closeModal = () => {
    dispatch(clearFileUploadStates());
    dispatch(hideModal(modalTypes.UPLOAD_EXTERNAL_FILES));
  };

  const handleClose = () => {
    onFilesUploaded(fileUploadStates, dispatch, navigate, folderId);
    closeModal();
  };

  useEffect(() => {
    const finalFiles = collectionList.map((f) => ({
      hash: f.document.hash.trim(),
      content: {
        name: f.name,
      },
      source: FILE_SOURCES.SAM_GOV,
      status: f.status,
      error: f.error,
    }));
    setDisplayedFiles(finalFiles);
    dispatch(initFileUploadStates(finalFiles));
    collectionList.forEach((f) => {
      dispatch(
        updateFileUploadState({
          hash: f.document.hash.trim(),
          error: f.error,
          status: f.status,
          id: f.document.id,
        })
      );
    });
  }, [dispatch, collection]);

  return (
    <Modal
      className="upload_files_modal"
      onDismiss={handleClose}
      restrictWidth={false}
      backdrop
      show
    >
      <Modal.Header>
        <span>Analyzing Documents</span>
      </Modal.Header>
      <Modal.Body>
        <div className="upload_files_modal__description">
          We are currently adding and analyzing the documents
        </div>
        <div className="upload_files_modal__table_wrapper">
          <FilesTable files={displayedFiles} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <span className="upload_files_modal__uploading full">
          Adding from opportunity provider
        </span>
        <NewButton variant={NewButtonVariant.l1} onClick={handleClose}>
          Close
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

UploadExternalFilesModal.propTypes = {
  onFilesUploaded: func,
};

export default UploadExternalFilesModal;
